import { useEffect } from 'react';
import api from '../utils/api';

const ensureMetaTag = (attrName, attrValue) => {
  let tag = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attrName, attrValue);
    document.head.appendChild(tag);
  }
  return tag;
};

const ensureLinkTag = (relValue) => {
  let tag = document.head.querySelector(`link[rel="${relValue}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', relValue);
    document.head.appendChild(tag);
  }
  return tag;
};

const BrandingMetaSync = () => {
  useEffect(() => {
    let isMounted = true;

    const applyBranding = (companyName, logoUrl, logoVersion) => {
      if (!isMounted) {
        return;
      }

      const baseTitle = companyName ? `${companyName} ERP` : 'ERP';
      const absoluteLogoUrl = logoUrl.startsWith('http') ? logoUrl : `${window.location.origin}${logoUrl}`;
      document.documentElement.dataset.appName = baseTitle;

      const manifestLink = ensureLinkTag('manifest');
      manifestLink.href = `/api/company/manifest.webmanifest?v=${logoVersion || Date.now()}`;

      const iconLink = ensureLinkTag('icon');
      iconLink.type = 'image/jpeg';
      iconLink.href = logoUrl;

      const appleTouchIconLink = ensureLinkTag('apple-touch-icon');
      appleTouchIconLink.href = logoUrl;

      const applicationNameMeta = ensureMetaTag('name', 'application-name');
      applicationNameMeta.setAttribute('content', baseTitle);

      const appleMobileTitleMeta = ensureMetaTag('name', 'apple-mobile-web-app-title');
      appleMobileTitleMeta.setAttribute('content', baseTitle);

      const ogTitleMeta = ensureMetaTag('property', 'og:title');
      ogTitleMeta.setAttribute('content', baseTitle);

      const ogSiteNameMeta = ensureMetaTag('property', 'og:site_name');
      ogSiteNameMeta.setAttribute('content', baseTitle);

      const twitterTitleMeta = ensureMetaTag('name', 'twitter:title');
      twitterTitleMeta.setAttribute('content', baseTitle);

      const descriptionMeta = ensureMetaTag('name', 'description');
      descriptionMeta.setAttribute('content', `${baseTitle} yönetim platformu`);

      const ogDescriptionMeta = ensureMetaTag('property', 'og:description');
      ogDescriptionMeta.setAttribute('content', `${baseTitle} yönetim platformu`);

      const ogImageMeta = ensureMetaTag('property', 'og:image');
      ogImageMeta.setAttribute('content', absoluteLogoUrl);

      const twitterImageMeta = ensureMetaTag('name', 'twitter:image');
      twitterImageMeta.setAttribute('content', absoluteLogoUrl);

      const twitterCardMeta = ensureMetaTag('name', 'twitter:card');
      twitterCardMeta.setAttribute('content', 'summary');
    };

    const loadBranding = async () => {
      try {
        const response = await api.get('/api/company/public-branding');
        const payload = response?.data;

        if (!payload?.success || !payload?.data) {
          return;
        }

        const companyName = payload.data.companyName || 'ERP';
        const logoVersion = payload.data.logoVersion || Date.now();
        const logoUrl = payload.data.logoUrl || `/api/company/logo?logoVersion=${logoVersion}`;

        applyBranding(companyName, logoUrl, logoVersion);
      } catch (error) {
        // Branding senkronizasyonu kritik olmadığı için sessiz geç.
      }
    };

    loadBranding();

    return () => {
      isMounted = false;
    };
  }, []);

  return null;
};

export default BrandingMetaSync;
